export enum Role {
  SUPER = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  ADMIN_CKD = 'ADMINCKD',
  MASTER_ITEM = 'MASTERITEM',
  MASTER_SUPPLIER = 'MASTERSUPPLIER',
  MASTER_CUSTOMER = 'MASTERCUSTOMER',
  CKD_SUPER = 'CKDSUPERUSER',
  WAREHOUSE_ADMIN = 'WAR:ADMIN',
  WAREHOUSE_SUPERVISOR = 'WAR:SUPERVISOR',
  WAREHOUSE_OFFICER = 'WAR:OFFICER',
  PURCHASE_SUPERVISOR = 'PUR:SUPERVISOR',
  PURCHASE_OFFICER = 'PUR:OFFICER',
  QC_SUPERVISOR = 'QLC:SUPERVISOR',
  QC_OFFICER = 'QLC:OFFICER',
  PRODUCTION_SUPERVISOR = 'PRD:SUPERVISOR',
  PRODUCTION_TECHNICIAN = 'PRD:TECHNICIAN',
  PRODUCTION_OFFICER = 'PRD:OFFICER',
  PLANNING_SUPERVISOR = 'PLN:SUPERVISOR',
  PLANNING_OFFICER = 'PLN:OFFICER',
  SALES_SUPERVISOR = 'SLD:SUPERVISOR',
  SALES_OFFICER = 'SLD:OFFICER',
  ACCOUNTING_SUPERVISOR = 'ACF:SUPERVISOR',
  ACCOUNTING_OFFICER = 'ACF:OFFICER',
  QSS_OFFICER = 'QSS:OFFICER',
}

export const PurDeptRoles = [Role.PURCHASE_SUPERVISOR, Role.PURCHASE_OFFICER]
export const WarDeptRoles = [
  Role.WAREHOUSE_ADMIN,
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_OFFICER,
]
export const QlcDeptRoles = [Role.QC_SUPERVISOR, Role.QC_OFFICER]
export const PrdDeptRoles = [
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.PRODUCTION_OFFICER,
]
export const PlnDeptRoles = [Role.PLANNING_SUPERVISOR, Role.PLANNING_OFFICER]
export const SldDeptRoles = [Role.SALES_SUPERVISOR, Role.SALES_OFFICER]
export const AccountingDeptRoles = [
  Role.ACCOUNTING_SUPERVISOR,
  Role.ACCOUNTING_OFFICER,
]
export const SupervisorRoles = [
  Role.WAREHOUSE_SUPERVISOR,
  Role.PURCHASE_SUPERVISOR,
  Role.QC_SUPERVISOR,
  Role.PRODUCTION_SUPERVISOR,
  Role.PLANNING_SUPERVISOR,
  Role.SALES_SUPERVISOR,
  Role.ACCOUNTING_SUPERVISOR,
]

export const AllAdmins = [Role.SUPER, Role.ADMIN, Role.ADMIN_CKD]
